import clientConfig from '@kbbsdk/config/clientConfig';
export const getPixallScripts = ({
  enabledFlippers
}) => {
  const isGTMEnabled = clientConfig.enableGtm || enabledFlippers && enabledFlippers.indexOf('disable-gtm') === -1;
  const enablePixall = enabledFlippers.indexOf('perf-disable-pixall') === -1;
  return isGTMEnabled && clientConfig.enableInlinePixall ? [{
    children: `window.__ANALYTICS_PROVIDER__ = true`
  }, ...(enablePixall ? [{
    async: true,
    type: "text/javascript",
    src: clientConfig.pixallUrl
  }] : [])] : [];
};
export default ({
  enabledFlippers
}) => getPixallScripts({
  enabledFlippers
});